import { get, isUndefined, lowerCase } from 'lodash-es'

import API_CONSTANTS from '@/js/helper/api-constants'

import { byId } from '../../helper/store-selectors'

import BRAND_CONSTANTS from '../brands/brands-constants'

export const getBrands = data => {
  const brands = {}
  const relationships = get(data, API_CONSTANTS.RELATIONSHIPS)

  if (!isUndefined(relationships)) {
    const brandData = get(relationships, [BRAND_CONSTANTS.BRAND, API_CONSTANTS.DATA], [])

    brandData.forEach(brand => {
      const id = get(brand, API_CONSTANTS.ID)
      const attributes = get(brand, API_CONSTANTS.ATTRIBUTES)

      const brandName = get(attributes, BRAND_CONSTANTS.BRAND_NAME)
      const logoUrl = get(attributes, BRAND_CONSTANTS.LOGO_URL)
      const logoData = get(attributes, BRAND_CONSTANTS.LOGO_DATA)

      brands[id] = {
        brandName,
        logoUrl,
        logoData,
      }
    })
  }

  return brands
}

export const getBrandByPimId = (state, id) => {
  const brandId = get(state, [BRAND_CONSTANTS.BY_PIM_ID, lowerCase(id)])

  if (brandId) {
    return byId(state, brandId)
  }

  return undefined
}

export const getBrandById = (state, id) => byId(state, id) || getBrandByPimId(state, id)
